import { api } from ".";
import {
  Underpayment,
  IUnderpaymentResponse,
  IUnderpaymentFilters,
} from "../../types/underpayment";

/**
 * RTK Query API slice for underpayments endpoints
 * Provides hooks for fetching underpayment data with filtering, sorting, and pagination
 */
const underpaymentQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getUnderpayments: builder.query<
      IUnderpaymentResponse,
      IUnderpaymentFilters
    >({
      query: (filters) => {
        // Build query parameters
        const params: Record<string, string> = {
          accountId: filters.accountId,
        };

        if (filters.search) {
          params.search = filters.search;
        }

        if (filters.startDate) {
          [params.startDate] = filters.startDate.toISOString().split("T");
        }

        if (filters.endDate) {
          [params.endDate] = filters.endDate.toISOString().split("T");
        }

        if (filters.sortField) {
          params.sortField = filters.sortField;
        }

        if (filters.sortOrder) {
          params.sortOrder = filters.sortOrder;
        }

        if (filters.page) {
          params.page = filters.page.toString();
        }

        if (filters.pageSize) {
          params.pageSize = filters.pageSize.toString();
        }

        return {
          url: "/underpayments",
          params,
        };
      },
      transformResponse: (response: any): IUnderpaymentResponse => {
        // Transform ISO date strings to Date objects
        const data: Underpayment[] = response.data.map((item: any) => ({
          ...item,
          patientDOB: item.patientDOB ? new Date(item.patientDOB) : null,
          serviceDate: new Date(item.serviceDate),
          ediConversionFile: item.ediConversionFile
            ? {
                ...item.ediConversionFile,
                createdAt: new Date(item.ediConversionFile.createdAt),
              }
            : undefined,
        }));

        return {
          data,
          totalCount: response.totalCount,
          page: response.page,
          pageSize: response.pageSize,
          message: response.message,
        };
      },
      providesTags: ["Underpayments"],
    }),
  }),
});

export const { useGetUnderpaymentsQuery } = underpaymentQueries;
